import * as ActionTypes from 'Types/ShoppingCartActionTypes'

export const requestShoppingCartPage = () => ({
	type: ActionTypes.REQUEST_SHOPPINGCARTPAGE
})
export const receiveShoppingCartPage = (json) => ({
    type: ActionTypes.RECEIVE_SHOPPINGCARTPAGE,
    payload: json
})

export const requestUpdateShoppingCartProducts = (skusToRemove, skusToAdd) => ({
    type: ActionTypes.REQUEST_UPDATE_SHOPPINGCART_PRODUCTS,
    payload: {
        skusToRemove,
        skusToAdd
    }
})

export const updateDebugShippingQuoteState = (isSlideOutActive, debugShippingOption) => ({
    type: ActionTypes.UPDATE_DEBUG_SHIPPING_QUOTE_STATE,
    payload: {
        isSlideOutActive,
        debugShippingOption
    }
})
export const receiveUpdateShoppingCartProducts = (json) => ({
    type: ActionTypes.RECEIVE_UPDATE_SHOPPINGCART_PRODUCTS,
    payload: json
})

export const requestMoveBuildlistItemToCart = (buildlistItemId, productDetails) => ({
    type: ActionTypes.REQUEST_MOVE_BUILD_LIST_ITEM_TO_CART,
    payload: {
        buildlistItemId,
        productDetails,
    }
})

export const receiveMoveBuildlistItemToCart = (json) => ({
    type: ActionTypes.RECEIVE_MOVE_BUILD_LIST_ITEM_TO_CART,
    payload: json
})

export const requestMoveCartItemToBuildlist = (cartItemId, productDetails) => ({
    type: ActionTypes.REQUEST_MOVE_CART_ITEM_TO_BUILD_LIST,
    payload: {
        cartItemId,
        productDetails
    }
})

export const receiveMoveCartItemToBuildlist = (json) => ({
    type: ActionTypes.RECEIVE_MOVE_CART_ITEM_TO_BUILD_LIST,
    payload: json
})


export const requestRemoveItemFromBuildlist = (buildlistItemIds) => ({
    type: ActionTypes.REQUEST_REMOVE_BUILD_LIST_ITEM,
    payload: {
        buildlistItemIds
    }
})

export const requestMoveSavedForLaterPartToBuildList = (toListId, fromListId, itemId) => ({
    type: ActionTypes.REQUEST_MOVE_SAVED_FOR_LATER_PART_TO_BUILD_LIST,
    payload: {
        toListId,
        fromListId,
        itemId
    }
})

export const receiveRemoveItemFromBuildlist = (json) => ({
    type: ActionTypes.RECEIVE_REMOVE_BUILD_LIST_ITEM,
    payload: json
})

export const receiveMoveSavedForLaterPartToBuildList = (savedForLaterProducts) => ({
    type: ActionTypes.RECEIVE_MOVE_SAVED_FOR_LATER_PART_TO_BUILD_LIST,
    payload: savedForLaterProducts
})

export const enterCheckout = (orderPrice) => ({
    type: ActionTypes.ENTER_CHECKOUT,
    payload: {
        orderPrice
    }
})

export const hideShippingEstimate = shouldHide => ({
    type: ActionTypes.HIDE_SHIPPING_ESTIMATE,
    payload: shouldHide
})


